var path = 'views/error/forbidden.html';
var html = "<div> <h1 translate>forbidden.forbiddenHeader</h1> <p translate>forbidden.forbiddenDescription</p> </div> ";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;